module.exports = __webpack_public_path__ + "media/images/pages/enrichment/banner-flourish-dae748eb9bf407f6b0609e59cac0c3ce.svg";